<div class="content-compact"
    [ngClass]="AppSettings.IsRunningInSingularity ? 'content-compact-sso' : ''"
>
    <div class="consoleHeader" consoleHeaderOffset
    [ngClass]="AppSettings.IsRunningInSingularity ? 'consoleHeader-sso' : ''">
        <form name="frm" id="frm" (submit)="onFilter()">
            <div class="row flex-nowrap">
                <div class="col-auto d-flex header_section align-items-center">
                    <div ngbDropdown
                         class="w-auto dropdown-noarrow"
                         *ngIf="lstProperties && lstProperties.length > 1">
                        <button type="button"
                                class="btn btn-link firstFilter"
                                ngbDropdownToggle
                                title="{{'TITLE.TITLE_SELECT_PROPERTY' | translate}}">
                            <i class="ksv-icon-building"></i>
                        </button>
                        <div class="dropdown-menu scrollable-dropdown-menu"
                             ngbDropdownMenu>
                            <button type="button"
                                    class="dropdown-item pointer"
                                    *ngFor="let row of lstProperties"
                                    [ngClass]="{'active': RequestModel.PropertyId == row.PropertyId}"
                                    (click)="onPropertyChange(row.PropertyId)">
                                {{row.PropertyName}}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-auto topFilters header_section headerlink-2line">
                    <a *ngFor="let row of PropStatModel"
                       [ngClass]="(SelectedTab == row.Id ? 'active' : '')"
                       href="javascript:{}"
                       (click)="onTopFilter(row.Id)">
                        <div class="text-center" translate>{{row.Label}}</div>
                        <div class="small text-center">({{row.Value}})</div>
                    </a>
                </div>

                <div class="col-auto header_section d-flex align-items-center">
                    <div class="w-auto mr-2">
                        <div class="searchFilterResult">
                            <input type="text"
                                   [placement]="['bottom']"
                                   [(ngModel)]="KeywordSearch"
                                   name="KeywordSearch"
                                   [ngbTypeahead]="SearchString"
                                   [editable]="false"
                                   [resultTemplate]="SearchResult"
                                   class="form-control searchFilterResult"
                                   (selectItem)="onSearchFilter($event)"
                                   [inputFormatter]="SearchFilter_DisplayText" />
                        </div>
                    </div>
                </div>

                <div class="col-auto header_section d-flex align-items-center" *ngIf="SelectedTab == '1' || SelectedTab == '3'">
                    <SelectPMSDates
                                    #pmsDateFilter
                                    [Model]="RequestModel"
                                    (ModelChange)="didChangeDateRange($event)"
                                    [SelectedStatusTab]="SelectedTab"
                                    [PropertyId]="RequestModel.PropertyId">
                    </SelectPMSDates>
                </div>

                <div class="col-auto d-flex header_section align-items-center px-4"
                     [ngClass]="RequestModel.HasFilters ? 'backHightlight':''">
                    <div class="pointer"
                         (click)="jobFilter.onOpen(FilterRequestModel)"
                         title="{{'TITLE.TITLE_FILTERS' | translate}}">
                        <i class="fas fa-filter"></i>
                    </div>
                    <div class="ml-4 pointer"
                         (click)="onClearFilter()"
                         *ngIf="RequestModel.HasFilters">
                        <i class="fas fa-times fa-lg mr-2"></i>{{'TITLE.TITLE_CLEAR_FILTER' | translate}}
                    </div>
                </div>

                <div class="col-auto d-flex header_section align-items-center px-4">
                    <button type="button"
                            class="btn btn-primary"
                            (click)="onGuestDirectory()">
                        {{'LBL.LBL_GUEST_DIRECTORY' | translate}}
                    </button>
                </div>

                <div class="col d-flex justify-content-end">
                    <div class="header_section align-items-center px-3">
                        <div class="pointer"
                             (click)="OpenKeyModal()"
                             title="{{'TITLE.TITLE_LEGENDS' | translate}}">
                            <i class="fa fa-lg fa-key fa-fw"></i>
                        </div>
                    </div>
                    <div class="header_section align-items-center px-3">
                        <div class="pointer"
                             (click)="refreshGridData()"
                             title="{{'TITLE.TITLE_REFRESH' | translate}}">
                            <i class="fa fa-lg fa-sync-alt"></i>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="currentreservationconsole-body">
        <div *ngIf="!IsSubmitting && Model && Model.TotalRecords == 0"
             class="noRecords">
            <span translate>LBL.NO_RECORD_FOUND</span>
        </div>
        <sk-wave [isRunning]="IsSubmitting"></sk-wave>
        <div class="" *ngIf="Model && Model.TotalRecords > 0">
            <div class="row align-items-center no-gutters pagerow flex-nowrap sticky-paginator"
            [ngClass]="AppSettings.IsRunningInSingularity ? 'sticky-paginator-sso' : ''">
                <div class="col-auto mr-2">
                    <div ngbDropdown>
                        <button class="btn btn-link btn-nonlink p-0 mr-2"
                                id="selSort"
                                ngbDropdownToggle
                                title="{{'BTN.BTN_SORT_BY' | translate}}">
                            <i class="fas fa-sort mr-2"></i>{{
SortByText |
                            translate
                            }}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="selSort">
                            <button *ngFor="let row of SortParams"
                                    class="dropdown-item pointer"
                                    [ngClass]="{'active': row.Id == RequestModel.OrderBy}"
                                    (click)="onFilter(row)"
                                    translate>
                                {{row.Name}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-auto" *ngIf="Model && Model.TotalRecords > 0">
                    <ngb-pagination [maxSize]="5"
                                    [rotate]="true"
                                    [collectionSize]="Model.TotalRecords"
                                    [pageSize]="RequestModel.PageSize"
                                    [(page)]="RequestModel.PageNumber"
                                    [boundaryLinks]="true"
                                    (pageChange)="onPageChange()"></ngb-pagination>
                </div>
                <div class="col-auto ml-4" *ngIf="Model">
                    <span translate>LBL.TOTAL_RECORDS</span>:
                    <b>{{Model.TotalRecords}}</b>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="currentreservationconsole"
                         *ngIf="IsSubmitting == false && Model && Model.TotalRecords > 0">
                        <div class="grdGrid">
                            <div class="grdRow row pointer no-gutters"
                                 *ngFor="let row of Model.Result"
                                 (click)="onRowSelected(row)"
                                 [ngClass]="{'selected': SelectedReservation && row.TritonReservationId == SelectedReservation.TritonReservationId }">
                                <div class="col-auto grdCol grd-col-flex">

                                    <div class="roomStatus" *ngIf="row.RoomStatus">
                                        <div class="dirty-icon roomStatusicon"
                                             *ngIf="row.RoomStatus == 'DIRTY'">
                                            {{'LBL.DIRTY' | translate}}
                                        </div>
                                        <div class="clean-icon roomStatusicon"
                                             *ngIf="row.RoomStatus == 'CLEAN'">
                                            {{'LBL.CLEAN' | translate}}
                                        </div>
                                        <div class="inspected-icon roomStatusicon"
                                             *ngIf="row.RoomStatus == 'INSPECTED'">
                                            {{'LBL.INSPECTED' | translate}}
                                        </div>
                                        <div class="pickup-icon roomStatusicon"
                                             *ngIf="row.RoomStatus == 'PICKUP'">
                                            {{'LBL.PICKUP' | translate}}
                                        </div>
                                        <div class="ooo-icon roomStatusicon"
                                             *ngIf="row.RoomStatus == 'OUT OF ORDER' || row.RoomStatus == 'OUT OF SERVICE'">
                                            {{(row.RoomStatus == 'OUT OF ORDER' ? 'LBL.OUTOFORDER' : row.RoomStatus == 'OUT OF SERVICE' ? 'LBL.OUTOFSERVICE' : '') | translate}}
                                        </div>
                                    </div>

                                </div>
                                <div class="col-auto grdCol flex gap-8">
                                    <div
                                         class="ic-status active pl-1"
                                         title="{{'TITLE.TITLE_GLITCH_REGISTERED' | translate}}">
                                        <i class="fas fa-exclamation-circle"  *ngIf="row.IsGlitchRegistered == true"></i>
                                    </div>
                                    <div title="{{'TITLE.TITLE_LOCATION' | translate}} - {{row.LocationDescription}}">
                                        <i class="fas fa-map-marker-alt fa-fw"></i>&nbsp;{{row.LocationDescription}}
                                    </div>
                                    <div *ngIf="masterService.LoggedInUserData.Properties.length > 1"
                                         title="{{'TITLE.TITLE_PROPERTY' | translate}} - {{row.PropertyCode}}"
                                         class="text-muted">
                                        {{row.PropertyCode}}
                                    </div>
                                </div>
                                <div class="col-auto grdCol d-none">
                                    <div [ngSwitch]="row.GuestType">
                                        <img src="/Images/guest_prearrival.png"
                                             class="img-fluid"
                                             *ngSwitchCase="1" />
                                        <img src="/Images/guest_inhouse.png"
                                             class="img-fluid"
                                             *ngSwitchCase="2" />
                                        <img src="/Images/guest_dueout.png"
                                             class="img-fluid"
                                             *ngSwitchCase="8" />
                                        <img src="/Images/guest_checkout.png"
                                             class="img-fluid"
                                             *ngSwitchCase="3" />
                                    </div>
                                </div>

                                <div class="col-auto grdCol">
                                    <span *ngIf="row.VIP"
                                          class="text-danger"
                                          title="{{'TITLE.TITLE_VIP' | translate}}">
                                        <i class="fas fa-briefcase fa-fw"></i>
                                    </span>
                                </div>

                                <div class="col-auto grdCol">
                                    <div class="ellipsis"
                                         title="{{'TITLE.TITLE_GUEST_NAME' | translate}} - {{row.FullName}}">
                                        {{row.FullName}}
                                    </div>
                                    <div class="text-muted"
                                         title="{{'TITLE.TITLE_VIP' | translate}} - {{row.VIPDescription ? row.VIPDescription : row.VIP}}">
                                        {{
row.VIPDescription ?
                                        row.VIPDescription : row.VIP
                                        }}
                                    </div>
                                </div>

                                <div class="col-auto grdCol">
                                    <div class="align-items-center"
                                         title="{{'TITLE.TITLE_ARRIVAL_DATE' | translate}} & {{'TITLE.TITLE_DEPARTURE_DATE' | translate}}">
                                        <i class="fas fa-calendar-alt fa-fw"></i>
                                        <span>
                                            &nbsp;{{
row.ArrivalDate |
                                            amDateFormat: DateFormat
                                            }} -
                                            {{
row.DepartureDate | amDateFormat:
                                            DateFormat
                                            }}
                                        </span>
                                    </div>
                                    <div title="{{'TITLE.TITLE_PAX' | translate}}: {{row.Pax}}">
                                        <i class="fas fa-user-friends fa-fw"></i>&nbsp;{{row.Pax}}
                                    </div>
                                </div>

                                <div class="col-auto grdCol">
                                    <div *ngIf="row.GuestMemberShips && row.GuestMemberShips.length > 0 && CheckAuth_Dept_Action(row.PropertyId, 0, _AuthActionCodes.GuestProfile_Info)"
                                         class="ic-status active"
                                         title="{{'TITLE.TITLE_MEMBERSHIP' | translate}} - {{row.GuestMemberShipTitle}}">
                                        <i class="fas fa-heart"></i>
                                    </div>
                                </div>
                                <div class="col-1 grdCol">
                                    <div *ngIf="row.ReservationStatus == 2 &&  row.JoinReservationId && row.JoinReservationId != row.PmsReservationId"
                                         data-html="true"
                                         class="ic-status secondarySharer"
                                         title="{{'TITLE.TITLE_SHARER' | translate}}">
                                        <span class="fa-stack">
                                            <i class="fas fa-briefcase fa-stack-1x sharer-icon-bottom"></i>
                                            <i class="fas fa-briefcase fa-stack-1x sharer-icon-top"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-auto grdCol">
                                    <div *ngIf="row.IsBirthday && CheckAuth_Dept_Action(row.PropertyId, 0, _AuthActionCodes.GuestProfile_Info)"
                                         class="ic-status active"
                                         title="{{'TITLE.TITLE_BIRTHDAY' | translate}}">
                                        <i class="fas fa-birthday-cake"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div [hidden]="SelectedReservation == null"
     [ngClass]=" SelectedGuests && SelectedGuests.length ? 'currentReservation-guest-popover' : ''"
     class="card-popover currentReservation-popover">
    <div class="card-header highlightHeader">
        <div class="d-flex justify-content-between">
            <div *ngIf="SelectedReservation && guestDetail && guestDetail.Model && guestDetail.Model.CountryCode">
                <img src="{{'Images/CountryFlags/' + (guestDetail.Model.CountryCode | lowercase) + '.png'}}"
                     class="img-fluid" />
            </div>
            <div *ngIf="!SelectedReservation || !guestDetail.Model || !guestDetail.Model.CountryCode">
                &nbsp;
            </div>

            <div class="" *ngIf="SelectedReservation">
                <div class="text-center">
                    {{SelectedReservation.LocationDescription}} -
                    {{SelectedReservation.FullName}}
                </div>
            </div>
            <button type="button"
                    class="close"
                    aria-label="Close"
                    (click)="onClose()">
                <span aria-hidden="true">
                    <i class="fas fa-times-circle"></i>
                </span>
            </button>
        </div>
    </div>

    <div class="card-title" *ngIf="!SelectedGuests || !SelectedGuests.length">
        <div class="d-flex justify-content-between border-bottom p-3">
            <div class="d-flex w-auto" *ngIf="SelectedReservation != null">
                <button type="button"
                        class="btn btn-primary mr-2"
                        [hidden]="SelectedReservation.ReservationStatus != 1 && SelectedReservation.ReservationStatus != 6"
                        (click)="setAlert(_AlertType.CheckIn)"
                        translate>
                    BTN.BTN_CHECK_IN_ALERT
                </button>
                <button type="button"
                        class="btn btn-primary mr-2"
                        [hidden]="SelectedReservation.ReservationStatus != 2"
                        (click)="setAlert(_AlertType.CheckOut)"
                        translate>
                    BTN.BTN_CHECK_OUT_ALERT
                </button>
                <button type="button"
                        class="btn btn-primary mr-2"
                        *ngIf="SelectedReservation.GuestId != null && CheckAuth_Dept_Action(SelectedReservation.PropertyId, 0, _AuthActionCodes.FrontOffice) && CheckAuth_Dept_Action(SelectedReservation.PropertyId, 0, _AuthActionCodes.TagStaff_Guest)"
                        translate
                        (click)="onTagStaff()">
                    BTN.BTN_TAG_STAFF
                </button>
            </div>
        </div>
    </div>

    <div class="guestBody">
        <GuestDetail #guestDetail></GuestDetail>
    </div>
</div>

<ng-template #SearchResult let-row="result" let-t="term" class="">
    <div class="d-flex justify-content-between align-items-center">
        <div class="w-auto d-flex align-items-center">
            <div class="w-auto mr-2"
                 title="{{'TITLE.TITLE_SEARCH' | translate}}">
                <div class="searchIcon"><i class="fas fa-search"></i></div>
            </div>
            <div class="w-auto mr-2">{{t}}</div>
        </div>
        <div class="w-auto">
            <div class="entityName text-muted">
                {{
'ENTITIES.ENTITIES_' + row.EntityName | uppercase |
                translate
                }}
            </div>
        </div>
    </div>
</ng-template>

<ng-template #guestKey let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_KEY</h6>
        <button type="button"
                class="close"
                aria-label="Close"
                (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid">
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 ic-status active px-0">
                    <i class="fas fa-exclamation-circle"></i>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_LOGGED_GLITCHES_GUEST
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 ic-status active px-0">
                    <i class="fas fa-briefcase"></i>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_GUEST_VIP
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0">
                    <i class="fas fa-map-marker-alt"></i>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_LOCATION_GUEST
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0">
                    <i class="fas fa-user-friends"></i>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_PAX
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 ic-status active px-0">
                    <i class="fas fa-heart"></i>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_MEMBERSHIP
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 ic-status active px-0">
                    <i class="fas fa-birthday-cake"></i>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_BIRTHDAY_TODAY
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 secondarySharer px-0">
                    <span class="fa-stack">
                        <i class="fas fa-briefcase fa-stack-1x sharer-icon-bottom"
                           style="font-size: 11px;margin-left:6px;"></i>
                        <i class="fas fa-briefcase fa-stack-1x sharer-icon-top"
                           style="font-size: 11px;margin-left:-2px;"></i>
                    </span>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_SECONDARY_SHARER
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-sync-alt"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_REFRESH
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0">
                    <i class="fas fa-calendar-alt"></i>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_CHECKIN_CHECKEDOUT_DATE
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-sort"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_SORT
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 text-primary pl-0">
                    <i class="fas fa-info-circle"></i>
                </div>
                <div translate>
                    ICON_DEF.ICON_DEF_USR_INFO
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-bell"></i></div>
                <div translate>
                    ICON_DEF.ICON_DEF_NOTIFICATION
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex px-0">
                <div class="statusIcon col-1 connectionIcon">
                    <i class="ksv-icon-connection-off statusIcon-Error"></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CONNECTION_FAIL
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="statusIcon col-1 connectionIcon">
                    <i class="ksv-icon-connection-on statusIcon-Sucess"></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CONNECTION_SUCCESS
                </div>
            </div>
            </div>




    </div>
    <div class="modal-footer ">
        <button type="button"
                class="btn btn-primary mr-3"
                (click)="c('close')"
                translate>
            BTN.BTN_OK
        </button>
    </div>
</ng-template>

<JobFilter #jobFilter
           (ApplyFilter)="onFilter()"
           [EnabledFilters]="EnabledFilters"></JobFilter>
<TagStaff #tagStaff></TagStaff>
<JobPopover #jobPopover
            [increasePopupOpacity]="complainService.increasePopupOpacity"
            [Selected]="complainService._SelectedJob"
            [Mode]="_JobPopoverMode.ReadOnly"></JobPopover>
<GlitchPopover #glitchPopover
                [increasePopupOpacity]="complainService.increasePopupOpacity"
               [Selected]="glitchService._SelectedGlitch"
               [Mode]="_JobPopoverMode.ReadOnly"></GlitchPopover>

<GuestSearchPopup #guestSearchPopup
                  (SelectionChanged)="onGuestDetails($event)">
</GuestSearchPopup>
